export const START_GAME = 'START_GAME';
export const ADD_PLAYERS = 'ADD_PLAYERS';
export const ADD_BIDS = 'ADD_BIDS';
export const RESET_BIDS = 'RESET_BIDS';
export const ADD_SCORES = 'ADD_SCORES';
export const RESET_GAME = 'RESET_GAME';


// WEBPACK FOOTER //
// ./src/state/action-types.js